// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__2oEGA","content":"ManualTimeModal_content__2Hrel"};